import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";
import { useInvalidateShopDomains } from "./use-shop-domains";

export default function useRemoveDomain(shop: ShopDto) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShopDomains = useInvalidateShopDomains(shop.id);
	const mutation = $api.useMutation(
		"delete",
		"/shops/{shopId}/preferences/notifications/domains/{name}",
	);

	return useMutation({
		onSuccess: () => {
			successNotification();
			invalidateShopDomains();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async (domainName: string) => {
			return mutation.mutateAsync({
				params: { path: { shopId: shop.id, name: domainName } },
			});
		},
	});
}
